import { actions } from './actions'

const initialState = {
  bibliotecasPredSvg: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaPredSvg: {
    data: null,
    loading: false,
    error: '',
  },
  enums: {
    data: null,
    loading: false,
    error: '',
  },
  objetosSvg: [],
  bibliotecasPredSvgByProducto: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function bibPredSvgReducer(state = initialState, action) {
  switch (action.type) {
    case actions.BIBPREDSVG_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredsvg, data: null, loading: true },
      }
    case actions.BIBPREDSVG_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPredSvg: {
          ...state.bibliotecasPredSvg,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBPREDSVG_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredSvg, loading: false, error: action.error },
      }
    case actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredsvg, data: null, loading: true },
      }
    case actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPredSvg: {
          ...state.bibliotecasPredSvg,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_FILED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredSvg, loading: false, error: action.error },
      }
    case actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPredSvgByProducto: {
          ...state.bibliotecasPredSvgByProducto,
          data: null,
          loading: true,
        },
      }
    case actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPredSvgByProducto: {
          ...state.bibliotecasPredSvgByProducto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_FILED:
      return {
        ...state,
        bibliotecasPredSvgByProducto: {
          ...state.bibliotecasPredSvgByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBPREDSVG_REQUESTED:
      return {
        ...state,
        bibliotecaPredSvg: { ...state.bibliotecasPredSvg, data: null, loading: true },
      }
    case actions.DELETE_BIBPREDSVG_SUCCEEDED: {
      return {
        ...state,
        bibliotecasPredSvg: {
          ...state.bibliotecasPredSvg,
          data: state.bibliotecasPredSvg.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBPREDSVG_FAILED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredSvg, loading: false, error: action.error },
      }
    case actions.BIBPREDSVG_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaPredSvg: { ...state.bibliotecaPredSvg, loading: true, error: '' },
      }
    case actions.BIBPREDSVG_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaPredSvg: {
          ...state.bibliotecaPredSvg,
          data: action.payload,
          loading: false,
          error: '',
        },
        objetosSvg: action.payload.bibliotecaPredSvgObjetos,
      }
    case actions.BIBPREDSVG_BYID_LOAD_FILED:
      return {
        ...state,
        bibliotecaPredSvg: {
          ...state.bibliotecaPredSvg,
          data: null,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPREDSVG_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaPredSvg: { ...state.bibliotecaPredSvg, loading: true, error: '' },
      }
    case actions.BIBPREDSVG_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaPredSvg: {
          ...state.bibliotecaPredSvg,
          data: {
            ...action.payload,
            svgString:
              action.payload.svgString !== null
                ? action.payload.svgString
                : state.bibliotecaPredSvg.data.svgString,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBPREDSVG_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaPredSvg: { ...state.bibliotecaPredSvg, loading: false, error: action.error },
      }
    case actions.BIBSPREDSVG_PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecasPredSvgByProducto: {
          ...state.bibliotecasPredSvgByProducto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBSPREDSVG_PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPredSvgByProducto: {
          ...state.bibliotecasPredSvgByProducto,
          data: [...action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.BIBSPREDSVG_PRODUCTO_UPDATE_FAILED:
      return {
        ...state,
        bibliotecasPredSvgByProducto: {
          ...state.bibliotecasPredSvgByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPREDSVG_INSERT_REQUESTED:
      return {
        ...state,
        bibliotecaPredSvg: { ...state.bibliotecaPredSvg, loading: true, error: '' },
      }
    case actions.BIBPREDSVG_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecaPredSvg: {
          ...state.bibliotecaPredSvg,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.BIBPREDSVG_INSERT_FAILED:
      return {
        ...state,
        bibliotecaPredSvg: { ...state.bibliotecaPredSvg, loading: false, error: action.error },
      }
    case actions.BIBPREDSVG_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredSvg, data: null, loading: true },
      }
    case actions.BIBPREDSVG_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredSvg, data: action.payload, loading: false },
      }
    case actions.BIBPREDSVG_FILTERED_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPredSvg: { ...state.bibliotecasPredSvg, loading: false, error: action.error },
      }
    case actions.ENUMS_LOAD_REQUESTED:
      return {
        ...state,
        enums: { ...state.enums, data: null, loading: true },
      }
    case actions.ENUMS_LOAD_SUCCEEDED:
      return {
        ...state,
        enums: { ...state.enums, data: action.payload, loading: false },
      }
    case actions.ENUMS_LOAD_FAILED:
      return {
        ...state,
        enums: { ...state.enums, loading: false, error: action.error },
      }
    case actions.UPDATE_BIBPREDSVG_OBJETOS:
      return {
        ...state,
        objetosSvg: action.payload,
      }
    default:
      return state
  }
}
